export default __webpack_public_path__ + "static/why-tecalis_03-fe676c96abe1c29ad19f196df02c7ee4.png";